module.exports = __webpack_public_path__ + "img/palpebra.5ff97b1b.svg";